import { render, staticRenderFns } from "./NewWindow.vue?vue&type=template&id=61d880b6"
import script from "./NewWindow.vue?vue&type=script&setup=true&lang=js"
export * from "./NewWindow.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports